/* Pure rules for what the desk can do right now. No DOM, no storage, so they
   can be tested under node. `online` means the app's own host answered; the
   ticket API is only known to be reachable once a roster refresh succeeds. */

export const REFRESH_AFTER_MIN = 15;

export function deskStatus({ online, sessionValid }) {
  if (online && sessionValid) {
    return { state: 'online', label: 'Online', canRefresh: true, needsSignIn: false };
  }
  if (sessionValid) {
    return { state: 'offline', label: 'Offline', canRefresh: false, needsSignIn: false };
  }
  if (online) {
    return { state: 'expired', label: 'Session expired', canRefresh: false, needsSignIn: true };
  }
  return { state: 'offline-expired', label: 'Offline · session expired', canRefresh: false, needsSignIn: false };
}

export function shouldAutoRefresh({ online, sessionValid, loadedAt, now = Date.now() }) {
  if (!online || !sessionValid) return false;
  const then = Date.parse(loadedAt);
  return !Number.isFinite(then) || now - then >= REFRESH_AFTER_MIN * 60000;
}
